import { Settings } from "./../Settings";
import { ISalvageClientSettings } from "../interfaces/ISalvageClientSettings";

export function GetClientSettings(): ISalvageClientSettings {
  return Settings;
}
